export default __webpack_public_path__ + "static/media/Leggings of the Unutterable.9f57fe9e.jpg";